import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ScrollService } from '../../core/scroll.service';
import { AuthService, IUserInfo } from '../../api/auth.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';
import { IAccountType } from '../../constants/account-types';
import { RouteViewBaseComponent } from '../../core/route-view-base/route-view-base.component';
import { LoginGuardService } from '../../api/login-guard.service';

interface ILoginFormErrors {
  isBlank?:boolean,
  isInvalid?: boolean,
}
@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  public breadcrumb = [];
  private userSub:Subscription;

  constructor(
    private auth: AuthService,
    private lang: LangService,
    private loginGuard: LoginGuardService, // this.loginGuard.deactivate();
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    private langService:LangService,
  ) {

  }
  
  ngOnInit() {
    this.loginGuard.deactivate();
    this.scrollService.scrollToTop();
    this.userSub = this.auth.user().subscribe(u => this.gotoUserDashboard(u));
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_login'), this.router.url),
    ];
  }

  ngOnDestroy() {
    if (this.userSub){
      this.userSub.unsubscribe();
    }
  }

  public gotoUserDashboard(userInfo:IUserInfo){
    const langCode = this.langService.getCurrentLanguage();
    if (userInfo){
      const accountType = userInfo.accountType;
      switch(accountType){
        case IAccountType.TEST_ADMIN : 
        case IAccountType.TEST_TAKER : 
        case IAccountType.TEST_CTRL  : 
        case IAccountType.CERT_BODY  : 
          return this.router.navigate([langCode, accountType, 'dashboard']);
        default:
          throw new Error('Unkown user type')
      }
    }
  }

}
